import type { EditorCatalog } from './es'

export const ca = {
  'load.loading': 'Obrint el curs…',
  'load.error': "No s'ha pogut obrir el curs. Torna-ho a provar d'aquí a uns minuts.",
  'load.retry': 'Torna-ho a provar',
  'load.notFound': 'Aquest curs no existeix o ja no està disponible.',
  'load.archived': 'Aquest curs està arxivat i ja no es pot editar.',
  'load.importPending.catalog':
    "Aquest curs té una versió importada que encara no s'ha publicat. Publica-la amb l'eina d'operador abans d'editar-lo aquí.",
  'load.importPending.organization':
    'Aquest curs té una versió que Eklevo ha importat i encara no ha publicat. El podràs editar quan Eklevo la publiqui.',
  'load.notAllowed': 'No pots editar aquest curs.',

  'create.title': 'Crea un curs nou',
  'create.body': 'Es crea com a esborrany, sense lliçons: ningú no el veu fins que es publica.',
  'create.name': 'Nom del curs',
  'create.description': 'Descripció',
  'create.series.hint':
    'Opcional, amb el nivell. Lletres minúscules, xifres i guionets, per exemple «lideratge».',
  'create.submit': "Crea'l i comença a editar-lo",
  'create.busy': 'Creant…',
  'create.cancel': 'Cancel·la',
  'create.error': "No s'ha pogut crear el curs. Torna-ho a provar d'aquí a uns minuts.",
  'create.error.limit':
    'La teva organització ha arribat al màxim de cursos propis. Per crear-ne un altre, descarta un esborrany que no necessitis o escriu a hola@eklevo.com.',

  'page.breadcrumb': 'Ruta',
  'page.breadcrumb.edit': 'Edita',
  'page.untitled': 'Curs sense títol',
  'page.status.draft': 'Esborrany',
  'page.status.published': 'Publicat · versió {version, number}',

  'outline.title': 'Contingut del curs',
  'outline.empty': 'Encara no hi ha cap lliçó.',
  'outline.lesson': 'Lliçó {number, number}: {title}',
  'outline.lesson.untitled': 'Lliçó {number, number}: Sense títol',
  'outline.intermediate': 'Avaluació intermèdia: {title}',
  'outline.intermediate.untitled': 'Avaluació intermèdia',
  'outline.final': 'Avaluació final: {title}',
  'outline.final.untitled': 'Avaluació final',
  'outline.hasProblems': 'Té camps per revisar',
  'outline.add': 'Afegeix una lliçó',
  'outline.addIntermediate':
    'Afegeix una avaluació intermèdia després de la lliçó {number, number}',
  'outline.intermediateTaken':
    'La lliçó {number, number} ja té una avaluació intermèdia al darrere.',
  'outline.addFinal': "Afegeix l'avaluació final",
  'outline.finalBlocked':
    "L'última lliçó ja té una avaluació intermèdia al darrere: mou-la o elimina-la per afegir la final.",
  'outline.full': 'Un curs té com a màxim {max, number} lliçons.',
  'outline.drag': 'Arrossega per moure',
  'outline.moveUp': 'Puja la lliçó {number, number}',
  'outline.moveDown': 'Baixa la lliçó {number, number}',
  'outline.remove': 'Elimina la lliçó {number, number}',
  'outline.removeAssessment': 'Elimina «{name}»',
  'outline.moved': "«{title}» s'ha mogut a la posició {number, number} de {count, number}.",
  'outline.moved.untitled':
    "La lliçó sense títol s'ha mogut a la posició {number, number} de {count, number}.",

  'general.title': 'Informació general',
  'general.courseTitle': 'Títol del curs',
  'general.description': 'Descripció breu',
  'general.description.count': '{count, number}/{max, number} caràcters',
  'general.longDescription': 'Descripció del curs',
  'general.longDescription.hint':
    'Opcional. De què tracta el curs, amb més detall: surt a la pàgina del curs, sota la descripció breu.',
  'general.objectives': 'Objectius del curs',
  'general.objectives.hint':
    'Opcional. Què sabrà fer la persona quan acabi el curs. Surt a la pàgina del curs.',
  'general.language': 'Idioma del curs',
  'general.language.newVersion':
    "Canviar l'idioma d'un curs publicat crea una versió nova en publicar: només la reben les assignacions noves.",
  'general.series': 'Sèrie',
  'general.series.hint':
    "Opcional. Els cursos d'una mateixa sèrie en són els nivells. Lletres minúscules, xifres i guionets, per exemple «lideratge».",
  'general.level': 'Nivell',
  'general.level.none': 'Sense nivell',
  'general.level.option': 'Nivell {level, number}',
  'general.level.hint': 'Opcional. Va amb la sèrie: tots dos o cap.',
  'general.minutes': 'Temps estimat per acabar-lo (minuts)',
  'general.department': 'Departament',
  'general.department.none': 'Sense departament',
  'general.department.hint': 'El departament que porta aquest programa. Es desa en triar-lo.',
  'general.department.saving': 'Desant el departament…',
  'general.department.error': "No s'ha pogut desar el departament. Torna a triar-lo.",

  'number.invalid': 'Escriu un nombre enter entre {min, number} i {max, number}.',
  'format.hint': 'Pots fer servir **negreta**, *cursiva* i llistes amb «-».',

  'language.es': 'Castellà',
  'language.ca': 'Català',
  'language.en': 'Anglès',

  'lesson.heading': 'Lliçó {number, number}',
  'lesson.none.title': 'Aquest curs encara no té lliçons',
  'lesson.none.body': "Afegeix la primera lliçó per començar a escriure'n el contingut.",
  'lesson.title': 'Títol de la lliçó',
  'lesson.description': 'Descripció de la lliçó',
  'lesson.objectives': 'Objectius de la lliçó',
  'lesson.objectives.hint': "Opcional. Què s'aprèn en aquesta lliçó.",
  'lesson.keyIdeas': 'Idees clau',
  'lesson.keyIdeas.hint':
    'Opcional. Només les llegeix la Noa, a les empreses que la tenen activada: la persona no les veu.',
  'lesson.optional': 'Opcional.',
  'lesson.minutes': 'Durada (minuts)',
  'lesson.remove': 'Elimina la lliçó',
  'lesson.assessment.title': 'Avaluació intermèdia',
  'lesson.assessment.none':
    "Una avaluació intermèdia és una prova amb nota que va just després d'aquesta lliçó: per passar a la següent, cal superar-la. Té les seves pròpies preguntes, que no s'agafen del test de la lliçó.",
  'lesson.assessment.add': 'Afegeix una avaluació intermèdia',
  'lesson.assessment.has': "Després d'aquesta lliçó va «{title}».",
  'lesson.assessment.hasUntitled':
    "Després d'aquesta lliçó va una avaluació intermèdia sense títol.",
  'lesson.assessment.open': "Edita l'avaluació",
  'lesson.assessment.last': "Després de l'última lliçó va l'avaluació final.",

  'video.title': 'Vídeo',
  'video.source': 'Origen del vídeo',
  'video.source.file': 'Puja un fitxer',
  'video.source.external': 'Enllaç extern',
  'video.upload.formats': 'Formats acceptats: MP4 (H.264). Mida màxima: 500 MB.',
  'video.upload.choose': 'Tria el vídeo',
  'video.file.waiting': 'Vídeo sense fitxer: la pujada no va acabar.',
  'video.file.again': 'Torna a pujar el vídeo',
  'video.file': 'Vídeo pujat',
  'video.file.captions': 'Amb subtítols.',
  'video.file.noCaptions': 'Sense subtítols.',
  'captions.title': 'Subtítols',
  'captions.formats': 'Format WebVTT (.vtt), fins a 2 MB. Opcional.',
  'captions.choose': 'Afegeix subtítols',
  'captions.file': 'Subtítols pujats.',
  'captions.waiting': 'Subtítols sense fitxer: la pujada no va acabar.',
  'captions.again': 'Torna a pujar els subtítols',
  'captions.remove': 'Treu els subtítols',
  'video.file.replace':
    'Per canviar-lo per un altre vídeo o per un enllaç de YouTube o Vimeo, treu primer el vídeo pujat.',
  'video.remove': 'Treu el vídeo',
  'video.newVersion':
    "Afegir un vídeo a aquesta lliçó o treure-l'hi canvia l'estructura del curs: en publicar, serà una versió nova. Canviar l'enllaç, el fitxer o els subtítols d'un vídeo és una correcció.",
  'video.link': 'Enllaç de YouTube o Vimeo',
  'video.link.placeholder': 'https://www.youtube.com/watch?v=…',
  'video.link.youtube': 'Vídeo de YouTube.',
  'video.link.vimeo': 'Vídeo de Vimeo.',
  'video.link.unknown':
    'Aquest enllaç no és de YouTube ni de Vimeo: només es poden publicar vídeos de YouTube o Vimeo, amb https.',
  'practice.title': 'Pràctica',
  'practice.body':
    "Fins a {max, number} activitats per posar en pràctica el que s'ha vist. A la lliçó, van després del vídeo. No compten per completar-la.",
  'practice.empty': 'Aquesta lliçó encara no té pràctica.',
  'practice.activity': 'Activitat {number, number}',
  'practice.kind': 'Tipus',
  'practice.kind.identification': 'Identificació',
  'practice.kind.case': 'Cas pràctic',
  'practice.kind.noa': 'Practicar amb la Noa',
  'practice.kind.other': 'Una altra',
  'practice.kind.noa.hint':
    'Al portal, aquesta activitat només surt a les empreses que tenen la Noa activada, amb el botó «Practicar amb la Noa».',
  'practice.name': "Títol de l'activitat",
  'practice.instructions': 'Instruccions',
  'practice.instructions.hint': 'Què ha de fer la persona.',
  'practice.minutes': "Durada de l'activitat (minuts)",
  'practice.scenario': 'Escenari per a la Noa',
  'practice.scenario.hint':
    'Opcional. Només el llegeix la Noa, quan la persona hi practica: el paper que fa la Noa i el que vol practicar la persona. La persona no el veu.',
  'practice.scenario.onlyNoa':
    "Només les activitats de «Practicar amb la Noa» tenen escenari: canvia el tipus o esborra l'escenari per poder publicar.",
  'practice.add': 'Afegeix una activitat',
  'practice.full': 'Una lliçó té com a màxim {max, number} activitats.',
  'practice.moveUp': "Puja l'activitat {number, number}",
  'practice.moveDown': "Baixa l'activitat {number, number}",
  'practice.remove': "Elimina l'activitat {number, number}",
  'practice.moved': "«{title}» s'ha mogut a la posició {number, number} de {count, number}.",
  'practice.moved.untitled':
    "L'activitat sense títol s'ha mogut a la posició {number, number} de {count, number}.",

  'materials.title': 'Materials',
  'materials.empty': 'Aquesta lliçó encara no té materials.',
  'materials.pdf': 'PDF',
  'materials.link': 'Enllaç',
  'materials.number': 'Material {number, number}',
  'materials.name': 'Nom',
  'materials.url': 'Enllaç (https)',
  'materials.description': 'Descripció',
  'materials.description.hint':
    'Opcional. Què hi trobarà la persona. Surt sota el nom del material.',
  'materials.file': 'Fitxer pujat.',
  'materials.file.waiting': 'Sense fitxer: la pujada no va acabar.',
  'materials.file.again': 'Torna a pujar el PDF',
  'materials.formats': 'PDF de fins a 50 MB.',
  'materials.addLink': 'Afegeix un enllaç extern',
  'materials.uploadPdf': 'Puja un PDF',
  'materials.full': 'Una lliçó té com a màxim {max, number} materials.',
  'materials.remove': 'Elimina el material {number, number}',
  'upload.sending': "S'està pujant {name}",
  'upload.percent': '{percent, number, percent}',
  'upload.progress': 'Progrés de la pujada',
  'upload.scanning': "S'està analitzant {name}: revisem que el fitxer sigui segur.",
  'upload.cancel': 'Cancel·la',
  'upload.cancel.label': 'Cancel·la la pujada de {name}',
  'upload.error.too-large': 'El fitxer supera la mida màxima.',
  'upload.error.empty': 'El fitxer és buit.',
  'upload.error.wrong-type': "El fitxer no és del format que s'accepta aquí.",
  'upload.error.quota-exceeded':
    "Aquest mes ja no es poden pujar més fitxers: l'organització ha arribat al límit de 20 GB.",
  'upload.error.infected':
    "La revisió de seguretat ha trobat un problema al fitxer, i no s'ha pujat.",
  'upload.error.scan-failed': "No s'ha pogut revisar el fitxer. Prova-ho amb un altre.",
  'upload.error.missing': 'El fitxer no ha arribat sencer. Torna a pujar-lo.',
  'upload.error.expired': 'La pujada ha caducat. Torna a pujar el fitxer.',
  'upload.error.network': "S'ha perdut la connexió mentre es pujava. Torna a pujar-lo.",
  'upload.error.scan-timeout': 'La revisió del fitxer tarda massa. Torna a pujar-lo més tard.',
  'upload.error.failed': "No s'ha pogut pujar el fitxer. Torna-ho a provar.",

  'reflection.title': 'Exercici de reflexió',
  'reflection.body':
    'Fins a {max, number} moments: preguntes obertes que la persona respon per escrit. A la lliçó, va després del vídeo i de la pràctica.',
  'reflection.intro': 'Introducció',
  'reflection.intro.hint':
    "Opcional. Surt abans dels moments: per a què serveix l'exercici o com s'ha de fer.",
  'reflection.intro.unseen':
    "Aquesta introducció no es veurà: sense moments, la lliçó no mostra l'exercici de reflexió.",
  'reflection.empty': 'Aquesta lliçó encara no té exercici de reflexió.',
  'reflection.moment': 'Moment {number, number}',
  'reflection.fixed':
    "Aquesta lliçó ja s'ha publicat: pots corregir el text de cada moment, però no en pots canviar l'ordre, ni afegir-ne ni treure'n. Les respostes de cada persona es desen per la seva posició.",
  'reflection.add': 'Afegeix un moment',
  'reflection.full': 'Una lliçó té com a màxim {max, number} moments.',
  'reflection.moveUp': 'Puja el moment {number, number}',
  'reflection.moveDown': 'Baixa el moment {number, number}',
  'reflection.remove': 'Elimina el moment {number, number}',
  'reflection.moved': "«{prompt}» s'ha mogut a la posició {number, number} de {count, number}.",
  'reflection.moved.untitled':
    "El moment sense text s'ha mogut a la posició {number, number} de {count, number}.",

  'test.title': 'Test',
  'test.body':
    'Preguntes de repàs de la lliçó, cadascuna amb quatre opcions i una de correcta. No té nota mínima, però cal enviar-lo per completar la lliçó: en enviar-lo, la persona veu les respostes correctes i les explicacions, i el pot repetir. Si vols una prova que calgui superar, afegeix una avaluació intermèdia després de la lliçó.',
  'test.empty': 'Aquesta lliçó encara no té test.',
  'test.question': 'Pregunta {number, number}',
  'test.prompt': 'Enunciat',
  'test.options': 'Opcions',
  'test.options.hint': "Marca amb el cercle l'opció correcta.",
  'test.option': 'Opció {number, number}',
  'test.correct': 'Correcta',
  'test.correct.label': "L'opció {number, number} és la correcta",
  'test.correct.none': "Marca quina és l'opció correcta.",
  'test.correct.pending':
    "Encara no has marcat l'opció correcta. Pots continuar, però caldrà per publicar.",
  'test.correct.pending.announce':
    "Pregunta {number, number}: encara no té marcada l'opció correcta.",
  'test.explanation': 'Explicació',
  'test.explanation.hint': 'Opcional. Es mostra després de respondre.',
  'test.add': 'Afegeix una pregunta',
  'test.full': 'Un test té com a màxim {max, number} preguntes.',
  'test.remove': 'Elimina la pregunta {number, number}',

  'assessment.intermediate': 'Avaluació intermèdia',
  'assessment.intermediate.body':
    "Una prova amb nota just després de la lliçó que triïs a «Va després de»: per continuar el curs, cal superar-la. Té les seves pròpies preguntes, que no s'agafen del test de la lliçó.",
  'assessment.final': 'Avaluació final',
  'assessment.final.body':
    "Una prova amb nota després de l'última lliçó: cal superar-la per completar el curs. Té les seves pròpies preguntes, que no s'agafen dels tests de les lliçons.",
  'assessment.remove': "Elimina l'avaluació",
  'assessment.title': "Títol de l'avaluació",
  'assessment.title.hint': 'Per exemple, «Repàs de les lliçons 1 a 3».',
  'assessment.minutes': 'Temps estimat (minuts)',
  'assessment.after': 'Va després de',
  'assessment.after.hint':
    "Una sola avaluació darrere de cada lliçó, i cap darrere de l'última si hi ha avaluació final.",
  'assessment.after.newVersion':
    "Moure-la a una altra lliçó canvia l'estructura del curs: en publicar, serà una versió nova.",
  'assessment.after.taken': '{lesson} (ja té una avaluació)',
  'assessment.after.last': "{lesson} (al darrere va l'avaluació final)",
  'assessment.after.unknown': 'Tria una lliçó',
  'assessment.rules': 'Per aprovar',
  'assessment.threshold': 'Nota mínima',
  'assessment.threshold.value': "{value, number} % d'encerts",
  'assessment.attempts': 'Intents',
  'assessment.attempts.value': '{value, plural, one {# intent} other {# intents}}',
  'assessment.rules.hint': "Són les mateixes a totes les avaluacions i no es canvien a l'editor.",
  'assessment.questions': "Preguntes de l'avaluació",
  'assessment.questions.body':
    "Cadascuna amb quatre opcions i una de correcta. Qui fa el curs no veu mai les respostes correctes d'una avaluació.",
  'assessment.questions.empty': 'Aquesta avaluació encara no té preguntes.',
  'assessment.questions.required':
    "Afegeix almenys una pregunta: sense preguntes, l'avaluació no es pot publicar.",
  'assessment.questions.full': 'Una avaluació té com a màxim {max, number} preguntes.',

  'save.cancel': 'Cancel·la',
  'save.now': 'Desa els canvis',
  'save.state.saved': 'Tots els canvis estan desats.',
  'save.state.savedAt': 'Canvis desats a les {at, time, short}.',
  'save.state.waiting': "Hi ha canvis sense desar. Es desen sols d'aquí a uns segons.",
  'save.state.saving': 'Desant…',
  'save.state.invalid': "No s'han pogut desar els canvis: revisa els camps marcats.",
  'save.state.tooLarge':
    'El curs és massa gran per desar-lo. Escurça textos o treu lliçons o preguntes, i es desarà sol.',
  'save.state.retrying':
    "No s'han pogut desar els canvis. Ho tornarem a provar d'aquí a uns segons.",
  'save.state.stopped': 'Els canvis ja no es poden desar.',

  'save.conflict': "El teu desament ha substituït canvis d'una altra persona.",
  'save.conflict.show': "Mostra l'avís",

  'stopped.gone':
    "Aquest esborrany ja no existeix: s'ha publicat o descartat des d'una altra pestanya. Torna a obrir el curs per continuar editant-lo.",
  'stopped.notFound': 'Aquest curs ja no existeix o ja no hi tens accés.',
  'stopped.archived': "Aquest curs s'ha arxivat i ja no es pot editar.",
  'stopped.notAllowed': 'No pots editar aquest curs.',
  'stopped.error': "No s'han pogut desar els canvis.",
  'stopped.reopen': 'Torna a obrir el curs',
  'reopen.title': 'Vols tornar a obrir el curs?',
  'reopen.body': "Es perdran els canvis que no s'han desat: el curs s'obre tal com està desat ara.",
  'reopen.confirm': 'Torna a obrir',

  'conflict.body':
    'Mentre editaves, una altra persona va desar canvis en aquest curs, a les {at, time, short}. El teu últim desament els ha substituït: revisa que no hi falti res.',
  'conflict.dismiss': 'Entesos',

  'issues.title':
    '{count, plural, one {Hi ha un camp per revisar} other {Hi ha # camps per revisar}}',
  'issues.body': "L'esborrany no s'ha desat amb aquests valors. Corregeix-los i es desarà sol.",
  'issues.at': '{place}: {problem}',
  'issues.course': 'Curs',

  'place.course.title': 'Títol del curs',
  'place.course.description': 'Descripció breu',
  'place.course.longDescription': 'Descripció del curs',
  'place.course.objectives': 'Objectius del curs',
  'place.course.language': 'Idioma del curs',
  'place.course.series': 'Sèrie',
  'place.course.level': 'Nivell',
  'place.course.estimatedMinutes': 'Temps estimat per acabar-lo',
  'place.course.lessons': 'Lliçons',
  'place.lesson': 'Lliçó {number, number}',
  'place.intermediate': 'Avaluació intermèdia',
  'place.final': 'Avaluació final',
  'place.intermediate.after': 'Avaluació després de la lliçó {number, number}',
  'place.estimatedMinutes': 'Temps estimat',
  'place.afterLessonKey': 'Va després de',
  'place.passThreshold': 'Nota mínima',
  'place.maxAttempts': 'Intents',
  'place.title': 'Títol',
  'place.description': 'Descripció',
  'place.objectives': 'Objectius',
  'place.keyIdeas': 'Idees clau',
  'place.durationMinutes': 'Durada',
  'place.video': 'Vídeo',
  'place.materials': 'Materials',
  'place.material': 'Material {number, number}',
  'place.name': 'Nom',
  'place.url': 'Enllaç',
  'place.reflection': 'Exercici de reflexió',
  'place.reflectionIntro': 'Introducció de la reflexió',
  'place.practice': 'Pràctica',
  'place.activity': 'Activitat {number, number}',
  'place.kind': 'Tipus',
  'place.instructions': 'Instruccions',
  'place.noaScenario': 'Escenari per a la Noa',
  'place.moment': 'Moment {number, number}',
  'place.test': 'Test',
  'place.questions': 'Preguntes',
  'place.question': 'Pregunta {number, number}',
  'place.prompt': 'Enunciat',
  'place.options': 'Opcions',
  'place.option': 'Opció {number, number}',
  'place.correct': 'Resposta correcta',
  'place.explanation': 'Explicació',
  'place.separator': ' · ',

  'problem.required': 'Falta aquesta dada.',
  'problem.too-long': 'És massa llarg.',
  'problem.too-few': 'Hi falten elements.',
  'problem.too-many': 'Hi ha massa elements.',
  'problem.out-of-range': "El valor és fora de l'interval permès.",
  'problem.invalid': 'El valor no és vàlid.',
  'problem.invalid-characters': 'Té caràcters que no es poden desar.',
  'problem.not-https': "L'enllaç ha de començar per https://.",
  'problem.video-host': 'Només es poden publicar vídeos de YouTube o Vimeo.',
  'problem.only-for-noa': 'Només les pràctiques amb la Noa tenen escenari.',
  'problem.duplicate-key': 'Aquest element està repetit.',
  'problem.unknown-lesson': 'La lliçó darrere de la qual va ja no existeix.',
  'problem.lesson-taken': "Ja hi ha una altra avaluació darrere d'aquesta lliçó.",
  'problem.after-last-lesson':
    "No pot anar darrere de l'última lliçó: allà hi va l'avaluació final.",
  'problem.series-and-level': 'La sèrie i el nivell van junts: posa-hi tots dos o cap.',
  'problem.video-or-material-required': 'Alguna lliçó ha de tenir un vídeo o un material.',
  'problem.file-not-clean': "El fitxer encara no s'ha revisat o no ha passat la revisió.",
  'problem.file-wrong-kind': "El fitxer no és del tipus que s'espera aquí.",
  'problem.file-not-found': 'El fitxer ja no està disponible.',
  'problem.reflection-fixed':
    "Aquesta lliçó ja s'ha publicat: els seus moments no es poden reordenar, ni afegir ni treure.",
  'problem.level-taken': 'Un altre curs de la sèrie ja té aquest nivell.',

  'actions.preview': 'Previsualitza com a persona empleada',
  'actions.preview.busy': 'Obrint la vista prèvia…',
  'actions.publish': 'Publica',
  'actions.publish.checking': 'Comprovant…',
  'actions.publish.busy': 'Publicant…',
  'actions.discard': "Descarta l'esborrany",
  'preview.title': 'Vista prèvia',
  'preview.body':
    'Així veurà cada lliçó una persona que fa el curs. El que responguis aquí no es desa.',
  'preview.marked':
    "Has previsualitzat aquesta versió de l'esborrany: si no canvies res, ja es pot publicar.",
  'preview.lessons': 'Lliçons',
  'preview.none': 'Aquest curs encara no té lliçons.',
  'preview.untitled': 'Lliçó sense títol',
  'preview.video.file': 'El vídeo pujat es veu al portal; la vista prèvia encara no el reprodueix.',
  'preview.reflection': 'A la vista prèvia, les respostes no es desen.',
  'preview.materials.pdf': 'Els PDF es descarreguen al portal.',
  'preview.noa':
    "Al portal, aquesta activitat només surt a les empreses que tenen la Noa activada; allà s'hi practica amb la Noa.",
  'preview.back': "Torna a l'editor",
  'publishPreview.title': 'Abans de publicar, previsualitza el curs',
  'publishPreview.body':
    "Els cursos del catàleg es publiquen després de veure com els veurà una persona. Obre'l a la vista prèvia i publica'l des d'allà.",
  'publishPreview.confirm': 'Previsualitza com a persona empleada',
  'publish.created.title': 'Vols publicar el curs?',
  'publish.created.body.catalog':
    'Serà la versió 1. Quedarà disponible per activar-lo a les empreses.',
  'publish.created.body.organization': 'Serà la versió 1. Quedarà disponible per assignar-lo.',
  'publish.newVersion.title': 'Vols publicar una versió nova?',
  'publish.newVersion.body':
    "L'estructura del curs ha canviat (les lliçons, quines tenen vídeo, les preguntes, les avaluacions o l'idioma): serà la versió {version, number}. Només la reben les assignacions noves; qui ja té el curs assignat continua amb la versió que tenia.",
  'publish.newVersion.confirm': 'Publica la versió nova',
  'publish.correction.title': 'Vols publicar una correcció?',
  'publish.correction.body':
    "L'estructura del curs no canvia: és una correcció de la versió {version, number}. Arriba a totes les persones que ja tenen el curs, sense canviar els intents que ja han fet.",
  'publish.correction.confirm': 'Publica la correcció',
  'publish.confirm': 'Publica',
  'publish.catalog': 'Val per a totes les empreses que tenen el curs.',
  'publish.passkey': "Et demanarem la clau d'accés per confirmar-ho.",
  'publish.error.save':
    "Per publicar cal desar abans els canvis, i no s'han pogut desar. Revisa l'avís del peu i torna-ho a provar.",
  'publish.error.changed':
    "Algú ha desat canvis en aquest curs mentrestant. Torna a obrir el curs per veure'ls.",
  'publish.error.changedDuringCheck':
    "El curs ha canviat mentre es comprovava. No s'ha publicat: torna a prémer «Publica».",
  'publish.error.gone':
    "Aquest esborrany ja no existeix: s'ha publicat o descartat des d'una altra pestanya. Torna a obrir el curs per continuar editant-lo.",
  'publish.error.generic': "No s'ha pogut publicar. Torna-ho a provar d'aquí a uns minuts.",
  'publish.error.limit':
    "Avui la teva organització ja ha publicat el màxim de versions noves dels seus cursos. Els canvis queden desats a l'esborrany: torna-ho a provar demà.",
  'preview.error': "No s'ha pogut obrir la vista prèvia. Torna-ho a provar d'aquí a uns minuts.",
  'discard.error': "No s'ha pogut descartar l'esborrany. Torna-ho a provar d'aquí a uns minuts.",
  'issues.publish.body':
    "L'esborrany està desat, però encara no es pot publicar: corregeix aquests camps i torna a publicar.",
  'discard.title': "Vols descartar l'esborrany?",
  'discard.body.new': "Aquest curs no s'ha publicat mai: s'eliminarà amb tot el contingut.",
  'discard.body.published':
    "Es perdran els canvis que no s'han publicat. El curs continuarà com està publicat (versió {version, number}).",
  'discard.confirm': "Descarta l'esborrany",
  'discard.busy': 'Descartant…',
  'done.published.created.catalog': 'Curs publicat: versió 1. Ja es pot activar a les empreses.',
  'done.published.created.organization': 'Curs publicat: versió 1. Ja es pot assignar.',
  'done.published.newVersion':
    'Versió {version, number} publicada. Només la reben les assignacions noves.',
  'done.published.correction':
    'Correcció publicada a la versió {version, number}: ja la veu tothom que té el curs.',
  'done.discarded.deleted': "Esborrany descartat. El curs no s'havia publicat mai i s'ha eliminat.",
  'done.discarded.kept':
    'Esborrany descartat. El curs continua com està publicat (versió {version, number}).',
  'done.back': 'Torna als cursos',
  'done.back.organization': 'Torna als programes',
  'done.edit': 'Continua editant',

  'leave.title': 'Vols sortir sense desar?',
  'leave.body': "Hi ha canvis que encara no s'han desat. Si surts ara, es perdran.",
  'leave.stay': 'Continua editant',
  'leave.confirm': 'Surt sense desar',

  'confirm.cancel': 'Cancel·la',
  'confirm.lesson.title': 'Vols eliminar la lliçó {number, number}?',
  'confirm.lesson.body':
    "S'eliminarà «{title}» amb el vídeo, la pràctica, la reflexió, els materials i el test.",
  'confirm.lesson.bodyUntitled':
    "S'eliminarà aquesta lliçó amb el vídeo, la pràctica, la reflexió, els materials i el test.",
  'confirm.lesson.assessments':
    "{count, plural, one {També s'eliminarà l'avaluació que va darrere seu.} other {També s'eliminaran les # avaluacions que van darrere seu.}}",
  'confirm.lesson.published':
    'Qui ja té el curs assignat la conserva: el canvi només arriba a les assignacions noves quan publiquis.',
  'confirm.lesson.confirm': 'Elimina la lliçó',
  'confirm.assessment.title': "Vols eliminar l'avaluació?",
  'confirm.assessment.body': "S'eliminarà «{title}» amb les seves preguntes.",
  'confirm.assessment.bodyUntitled': "S'eliminarà aquesta avaluació amb les seves preguntes.",
  'confirm.assessment.confirm': "Elimina l'avaluació",
  'confirm.question.title': 'Vols eliminar la pregunta {number, number}?',
  'confirm.question.body': "S'eliminarà la pregunta amb les opcions i l'explicació.",
  'confirm.question.confirm': 'Elimina la pregunta',
  'confirm.material.title': 'Vols eliminar el material {number, number}?',
  'confirm.material.body': 'Es traurà de la lliçó.',
  'confirm.material.confirm': 'Elimina el material',
  'confirm.moment.title': 'Vols eliminar el moment {number, number}?',
  'confirm.moment.body': "S'eliminarà la pregunta d'aquest moment.",
  'confirm.moment.confirm': 'Elimina el moment',
  'confirm.practice.title': "Vols eliminar l'activitat {number, number}?",
  'confirm.practice.body': "S'eliminarà l'activitat de la pràctica d'aquesta lliçó.",
  'confirm.practice.confirm': "Elimina l'activitat",
  'confirm.video.title': 'Vols treure el vídeo?',
  'confirm.video.body':
    "Es traurà el vídeo pujat d'aquesta lliçó, amb els seus subtítols. Després en podràs pujar un altre o afegir un enllaç de YouTube o Vimeo.",
  'confirm.video.confirm': 'Treu el vídeo',
  /** The title of a duplicate of a course, in the course's language (ADR 0009 §8). */
  'course.duplicateTitle': 'Còpia de {title}',
} as const satisfies EditorCatalog
